module.exports = __webpack_public_path__ + "img/publicity-poster-0126.eef9a8bc.jpg";